export default "__VITE_ASSET__BemGbseW__"